/**
 * Detection-zone overlay drawn over the evidence clip: a 10m advisory ring and
 * a 2.5m red exclusion ring projected onto the ground plane, plus a HUD readout.
 */
export default function DetectionOverlay({
  risk,
  redZone = 2.5,
  advisoryZone = 10,
  model,
}: {
  risk: number;
  redZone?: number;
  advisoryZone?: number;
  model: string;
}) {
  const danger = risk >= 70;
  return (
    <svg viewBox="0 0 320 180" className="pointer-events-none absolute inset-0 h-full w-full">
      <defs>
        <radialGradient id="zone" cx="50%" cy="100%" r="80%">
          <stop offset="0%" stopColor={danger ? "#EF4444" : "#F59E0B"} stopOpacity="0.28" />
          <stop offset="100%" stopColor="#EF4444" stopOpacity="0" />
        </radialGradient>
      </defs>
      {/* advisory zone */}
      <ellipse cx="160" cy="172" rx="150" ry="60" fill="url(#zone)" />
      <ellipse
        cx="160"
        cy="172"
        rx="150"
        ry="60"
        fill="none"
        stroke="#F59E0B"
        strokeWidth="1"
        strokeDasharray="4 4"
        opacity="0.5"
      />
      {/* red exclusion zone */}
      <ellipse
        cx="160"
        cy="172"
        rx="74"
        ry="30"
        fill="none"
        stroke="#EF4444"
        strokeWidth="1.4"
        opacity="0.85"
      />
      {/* detection box (person) */}
      <rect
        x="138"
        y="96"
        width="30"
        height="64"
        fill="none"
        stroke={danger ? "#EF4444" : "#22D3EE"}
        strokeWidth="1.6"
      />
      <text x="138" y="92" fill={danger ? "#EF4444" : "#22D3EE"} fontSize="8" fontFamily="monospace">
        person 0.9{Math.round(risk) % 9}
      </text>
      {/* HUD */}
      <text x="8" y="14" fill="#E8EEF4" fontSize="8" fontFamily="monospace">
        {model}
      </text>
      <text x="8" y="170" fill="#F59E0B" fontSize="8" fontFamily="monospace">
        ADVISORY {advisoryZone}m
      </text>
      <text x="232" y="170" fill="#EF4444" fontSize="8" fontFamily="monospace">
        RED {redZone}m
      </text>
      {danger && (
        <text x="118" y="50" fill="#EF4444" fontSize="13" fontWeight="bold" fontFamily="monospace">
          ⚠ DANGER ZONE
        </text>
      )}
    </svg>
  );
}
